<template>
	<div class="form_toolbar">
		<el-dropdown size="small" @command="handleCommand">
			<span class="el-dropdown-link">
				文件<span class="step">|</span>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item command="print" :disabled="id==0">报价单</el-dropdown-item>
				<el-dropdown-item command="contract" :disabled="id==0">合同</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-dropdown size="small" @command="handleCommand">
			<span class="el-dropdown-link">
				工具<span class="step">|</span>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item command="delivery">快递查询</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		
		
	</div>
</template>
<style scoped>
.step{
	margin: 0 10px;
}

</style>

<script>
	export default {
		props: {
			mainForm: {
				default: () => {
					return null
				}
			},
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				printShow:false,
				printObj: {
					id: "print_content", // 这里是要打印元素的ID
					popTitle: "&nbsp", // 打印的标题
					extraCss:'', // 打印可引入外部的一个 css 文件
					extraHead: "", // 打印头部文字
					preview:true,
					previewTitle:'报价单预览'
				},
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			handleCommand(command){
				this.$emit('buttonclick',command)
			},
		},
		components: {
			
		}
	}
</script>
